export default "/images/b5c2b21ed5b2443409dd532fa0d0fe48.avif";